import React from 'react';
import styled from 'styled-components';
import { FloatButton } from 'antd';
import { theme } from 'utils/style/theme';
/**
 * * 화면 위로 올라가기 버튼
 * 전체 화면에서 동일하게 사용
 */
interface IProps {
  children?: string | React.ReactElement;
}
const BackTopButton = () => {
  return (
    <FloatButton.BackTop />
    // <FloatButton.BackTop>탑{/* <button>TOP</button> */}</FloatButton.BackTop>
  );
};

export default BackTopButton;
const StyledBackTop = styled(FloatButton.BackTop)<IProps>`
  right: 0;
  button {
    background-color: ${theme.colors.blue_2};
    color: #ffffff;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    cursor: pointer;
    height: 40px;
    width: 42px;
    position: fixed;
    bottom: 20px;
    right: 0px;
  }
`;
